import React from 'react';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { BottomSection } from '../BottomSection';
import { CustomAccordion, CustomAccordionDetails, CustomAccordionSummary, } from '../CustomAccordion';
import MobileCustomerContainer from '../MobileCustomerContainer';
import SubMenuContainer from '../SubMenuContainer';
import { SubMenuSection } from '../SubMenuSection';
import { ACTION_TYPE } from '../types';
import { getActiveStatus } from '../utils';
import * as S from './styles';
const HEDER_TAG = 'HEADER';
const MobilePanel = ({ type, navItems, customer, actionItems, setMobilePanelDisplay, }) => {
    const closeMobilePanel = (e) => {
        const { target } = e;
        if (target.tagName !== HEDER_TAG) {
            setMobilePanelDisplay(false);
        }
    };
    let computedActionItems = actionItems;
    if (customer) {
        const { actionItems: customerActionItems } = customer;
        computedActionItems = [
            Object.assign(Object.assign({}, customerActionItems[0]), { type: ACTION_TYPE.Registration }),
        ];
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MobileCustomerContainer, { customer: customer }),
        React.createElement(S.CustomNav, { "$type": type },
            React.createElement(S.CustomSection, null,
                navItems.map(({ id, title, subMenus, enableBadge = false, href }) => {
                    const showBadge = enableBadge === true && (customer === null || customer === void 0 ? void 0 : customer.showUnreadMessage) === true;
                    const isActive = getActiveStatus(subMenus, href);
                    const mainHref = href || undefined;
                    return (React.createElement(CustomAccordion, { key: id, id: id },
                        React.createElement(CustomAccordionSummary, { href: href },
                            React.createElement(S.CustomLink, { "$isActive": isActive, href: mainHref, underline: "none" },
                                React.createElement(S.CustomBadge, { variant: "dot", invisible: !showBadge, color: "error" }, title))),
                        React.createElement(CustomAccordionDetails, null,
                            React.createElement(SubMenuContainer, { subMenus: subMenus, clickCallback: closeMobilePanel }))));
                }),
                (customer === null || customer === void 0 ? void 0 : customer.subMenus) ? (React.createElement(CustomAccordion, { key: "account-mobile-menu" },
                    React.createElement(CustomAccordionSummary, { href: undefined },
                        React.createElement(S.CustomLink, { "$isActive": undefined, href: undefined, underline: "none" },
                            React.createElement(ManageAccountsIcon, null))),
                    React.createElement(CustomAccordionDetails, null,
                        React.createElement(SubMenuSection, { items: customer.subMenus })))) : null)),
        computedActionItems ? (React.createElement(BottomSection, { actionItems: computedActionItems, headerType: type })) : null));
};
export default MobilePanel;
//# sourceMappingURL=index.js.map